<template>
  <div class="sidebar" :class="{ sidebar__close: !sidebar }">
    <div>
      <Header :close="close" />
      <!--       <div class="sidebar__header">
        <div class="burger close" @click="close">
          <span class="close-item"></span>
          <span></span>
        </div>
      </div> -->
    </div>
    <div class="sidebar__content">
      <div class="sidebar__nav">
        <div class="nav__box">
          <img
            alt="image"
            src="@/assets/img/svg/exchange-icon.svg"

          />
          <span class="nav__item" @click="openPage('Main')">Главная</span>
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/bill.svg" />
          <span class="nav__item" @click="openPage('Rules')"
            >Правила обмена</span
          >
        </div>
        <div class="nav__box">
          <img
            alt="image"
            src="@/assets/img/svg/partnership.svg"

          />
          <span class="nav__item" @click="openPage('Partners')"
            >Партнерская программа</span
          >
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/reviews.svg"  />
          <span class="nav__item" @click="openPage('Reviews')">Отзывы</span>
        </div>
      </div>
    </div>
    <div class="sidebar__bottom">
      <div class="unauth__bottom" v-if="!token">
        <p class="login__header">
          Войдите в аккаунт или зарегистрируйтесь, чтобы получить доступ к
          личному кабинету
        </p>

        <div class="sidebar__reg">
          <button @click="Login" class="redbtn">
            ВОЙТИ
          </button>
          <a @click.prevent="Register()" href="" class="reg__btn"
            >ЗАРЕГИСТРИРОВАТЬСЯ</a
          >
        </div>
      </div>

      <div class="sidebar__nav__bottom" v-if="token">
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/personal.svg"  />
          <span class="nav__item" @click="openCabinet('home')"
            >Личные данные</span
          >
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/link.svg"  />
          <span class="nav__item" @click="openCabinet('referal-link')"
            >Реферальная программа</span
          >
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/wallet.svg" />
          <span class="nav__item" @click="openCabinet('balance')"
            >Внутренний счет</span
          >
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/faq.svg" />
          <span class="nav__item" @click="openCabinet('faq')"
            >Партнерская программа FAQ</span
          >
        </div>
        <div class="nav__box">
          <img alt="image" src="@/assets/img/svg/logout.svg" />
          <span
            class="nav__item"
            @click="
              () => {
                $router.push('/logout');
                close();
              }
            "
            >Выйти</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/ui/Header";
export default {
  name: "Sidebar",
  components: { Header },
  data() {
    return {};
  },
  computed: {
    ...mapState("modals", ["sidebar"]),
    ...mapState("cabinet", ["page"]),
    ...mapState("auth", ["token", "login"]),
    ...mapState("info", ["info"])
  },
  methods: {
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["userLogin", "userRegister"]),
    open() {
      this.$store.commit("modals/open", true);
    },
    Login() {
      this.close();
      this.openModal({
        name: "login",
        success: this.userLogin
      });
    },

    Register() {
      this.close();
      this.openModal({
        name: "register",
        success: this.userRegister
      });
    },

    openPage(name) {
      this.$router.push({ name });
      this.close();
    },
    close() {
      this.$store.commit("modals/open", false);
    },
    openCabinet(name) {
      if (this.$route.name !== "Cabinet")
        this.$router.push({ name: "Cabinet" });
      this.$store.commit("cabinet/setPage", name);
      this.close();
    }
  }
};
</script>
<style scoped>
button {
  width: 100%;
}
.reg__btn {
  color: #1a1814;
  font-size: 15px;
  font-weight: 700;
  margin-top: 30px;
}
.login__header {
  font-size: 24px;
  color: var(--main-black);
  line-height: 28px;
  text-align: center;
}
.unauth__bottom {
  background-color: white;
  margin-bottom: 100px;
}
.nav__item {
  color: var(--main-black);
  font-size: 17px;
  font-weight: 500;
  line-height: 21.6px;
}
.nav__box {
  display: flex;
  gap: 10px;
  align-items: center;
}
.sidebar {
  z-index: 200;
  position: fixed;
  width: 100%;
  background-color: white;
  height: 100vh;
  overflow-y: scroll;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transform: translateX(0%);
  transition: transform 0.2s ease;
}

.sidebar__close {
  transform: translateX(-100%);
}
.sidebar__header {
  position: relative;
  height: 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.sidebar__header_logo {
  padding-top: 16px;
  padding-left: 16px;
}
.sidebar__content {
  display: flex;
  height: 100%;
  margin-bottom: 10px;
  flex-direction: column;
  justify-content: space-between;
}
.burger.close {
  position: absolute;
  width: 48px;
  height: 48px;
  background-color: var(--primary-v);
  right: 0;
  top: 0;
  margin-top: 0;
  margin-right: 0;
}
.burger.close > span {
  width: 20px;
}
.burger.close > span:first-child {
  top: calc(50% + 6px);
  left: calc(50% - 3px);
  transform: rotate(45deg) translate(-50%, -50%);
}

.burger.close > span:last-child {
  top: calc(50% - 8px);
  transform: rotate(-45deg) translate(-50%, -50%);
  left: calc(50% - 2px);
}
.sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: start;
  padding: 20px;
  font-size: 16px;
  line-height: 24px;
}
.sidebar__nav__bottom {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: start;
  padding: 4px;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 100px;
}
.sidebar__nav > span:not(:last-child) {
  margin-bottom: 16px;
}
.sidebar__nav {
  display: flex;
  justify-content: center;
}
.sidebar__reg {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: -16px;
  margin-right: -16px;
  padding: 30px 16px 24px;
  background-color: white;
}
.sidebar__reg > button:first-child {
  margin-bottom: 5px;
}
.sidebar__bottom {
  padding: 0 16px;

  background-color: white;
}
.sidebar__date {
  padding: 16px 0;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.sidebar__date-contet {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
}
.sidebar__profile {
  padding: 16px 16px 24px;
  background-color: var(--secondary-gray);
}
.sidebar__profile-list {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
}
.sidebar__profile-item {
}
.nav__item {
  display: flex;
  align-items: center;
}
.nav__item:not(:last-child) {
  margin-bottom: 24px;
}
.nav__item > img {
  margin-right: 8px;
}

.blog {
  text-transform: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Sidebar.vue